import type { FC } from "react";
import { SendBulkEmailsConfirmPage } from "./SendBulkEmailsConfirmPage";

const SendBulkEmailsConfirmPageContainer: FC = () => {
  return <SendBulkEmailsConfirmPage />;
};

export default SendBulkEmailsConfirmPageContainer;
